import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Layout } from "../components/Layout";
import { Compliance } from "../components/compliance";
import { useSEO } from "../hooks/useSEO";

export const CompliancePage = ({ data }) => {
  useSEO({
    title: "Compliance & Licensing | Transwave Shipping Dubai UAE",
    description:
      "Transwave Shipping and Logistics LLC is fully licensed by SHAMS, UAE. All freight forwarding, cargo handling, and logistics operations comply with UAE regulatory standards.",
    canonical: "https://www.transwaveshipping.com/compliance",
  });

  return (
    <Layout contactData={data.Contact}>
      {/* Page Hero — centered with badge icon */}
      <div className="page-hero page-hero--compliance">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Compliance &amp; Licensing</h1>
            <p>Fully licensed and operating in compliance with UAE regulatory standards</p>
            <nav className="page-breadcrumb" aria-label="breadcrumb">
              <Link to="/">Home</Link> <span>/</span> <span>Compliance</span>
            </nav>
          </motion.div>
        </div>
      </div>

      <Compliance />

      {/* Compliance Details */}
      <div className="compliance-detail-section">
        <div className="container">
          <div className="compliance-cards-grid">
            {[
              { icon: "fa fa-certificate", title: "SHAMS Licensed", text: "Fully licensed under Sharjah Media City (SHAMS) Free Zone authority, UAE." },
              { icon: "fa fa-shield", title: "Regulatory Compliance", text: "All operations adhere to UAE logistics, customs, and transport regulations." },
              { icon: "fa fa-file-text-o", title: "Documentation Standards", text: "Accurate, compliant shipping documentation for every consignment." },
              { icon: "fa fa-globe", title: "International Standards", text: "Aligned with global freight forwarding and FIATA guidelines." },
            ].map((item, i) => (
              <motion.div
                key={i}
                className="compliance-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
              >
                <div className="mv-header">
                  <div className="mv-icon"><i className={item.icon}></i></div>
                  <h3>{item.title}</h3>
                </div>
                <p>{item.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="page-cta">
        <div className="container text-center">
          <h3>Work with a compliant, trusted logistics partner</h3>
          <p>Contact us to discuss your freight requirements with confidence.</p>
          <Link to="/contact" className="btn btn-custom btn-lg">Contact Us</Link>
        </div>
      </div>
    </Layout>
  );
};
